// extracted by mini-css-extract-plugin
module.exports = {"checkoutPageWrapper":"StickyButton_checkoutPageWrapper__lXwfD"};